import { fetchUtils, HttpError, Identifier } from 'react-admin';
import {
  createReactAdminValidationError,
  getJsonApiErrorBody,
  getJsonApiErrorMessage,
  getJsonApiErrorStatus,
} from '../../JsonApiTypes';
import { defaultHeaders } from '../../utils';

export interface RecalculateBudgetStatusResponse {
  restoredClicks: number;
  chargeableSpend: number;
  monthlyBudget: number;
  mailCapStatusCode: number;
  overBudget: boolean;
}

export type RecalculateBudgetStatus = (
  merchantId: Identifier,
) => Promise<RecalculateBudgetStatusResponse>;

export default function recalculateBudgetStatus(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
): RecalculateBudgetStatus {
  return async (merchantId) => {
    try {
      const response = await httpClient(
        `${apiUrl}/merchants/${merchantId}/recalculate-budget-status`,
        {
          method: 'POST',
          headers: defaultHeaders,
        },
      );

      return (response.json ?? {}) as RecalculateBudgetStatusResponse;
    } catch (error) {
      const validationErrors = createReactAdminValidationError(error as HttpError);
      throw new HttpError(
        getJsonApiErrorMessage(error as HttpError, 'Error recalculating budget status'),
        getJsonApiErrorStatus(error as HttpError),
        {
          ...validationErrors,
          apiResponse: getJsonApiErrorBody(error),
        },
      );
    }
  };
}
